import React, { Component } from 'react';

export default class AddIcon extends Component {

    render(){
        const fillStyle = {fill:this.props.fillColor}
        return (
            <svg width="100%" height="100%" viewBox="0 0 80 80" style={this.props.svgStyle}>
              <g style={fillStyle}>
                <path d="M40,0.15c21.994,0 39.85,17.856 39.85,39.85c0,21.994 -17.856,39.85 -39.85,39.85c-21.994,0 -39.85,-17.856 -39.85,-39.85c0,-21.994 17.856,-39.85 39.85,-39.85Zm0,6.472c18.422,0 33.378,14.956 33.378,33.378c0,18.422 -14.956,33.378 -33.378,33.378c-18.422,0 -33.378,-14.956 -33.378,-33.378c0,-18.422 14.956,-33.378 33.378,-33.378Z"/>
                <path d="M40,60.181c-0.771,0 -1.41,-0.254 -1.918,-0.762c-0.508,-0.508 -0.762,-1.148 -0.762,-1.919l0,-23.386c0,-0.806 0.254,-1.454 0.762,-1.944c0.508,-0.491 1.147,-0.736 1.918,-0.736c0.806,0 1.454,0.245 1.944,0.736c0.491,0.49 0.736,1.138 0.736,1.944l0,23.386c0,0.771 -0.245,1.411 -0.736,1.919c-0.49,0.508 -1.138,0.762 -1.944,0.762Zm0,-33.424c-0.946,0 -1.761,-0.342 -2.444,-1.025c-0.683,-0.683 -1.025,-1.498 -1.025,-2.444c0,-0.946 0.342,-1.761 1.025,-2.444c0.683,-0.683 1.498,-1.025 2.444,-1.025c0.946,0 1.761,0.342 2.444,1.025c0.683,0.683 1.025,1.498 1.025,2.444c0,0.946 -0.342,1.761 -1.025,2.444c-0.683,0.683 -1.498,1.025 -2.444,1.025Z"/> 
              </g>
            </svg>
        )
    }
}
